import { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { mdiClose, mdiUpload } from "@mdi/js";
import Icon from "@mdi/react";

import { RespostaType } from "../../entities/QuestionnaireEntity";
import { QuestionEntity } from "../../entities/QuestionEntity";
import { QuestionnaireResponseQuestionFile } from "../../entities/QuestionnaireResponseEntity";

type FormFileProps = {
	pergunta: QuestionEntity;
	resposta: RespostaType | null;
	onChange: (value: RespostaType) => void;
};

const fileEmpty = {} as QuestionnaireResponseQuestionFile;

export default function FormFile(props: FormFileProps) {
	const [value, setValue] = useState({
		...props.resposta,
		questionId: props.pergunta.id!,
		files: props.resposta?.files ?? [fileEmpty],
	});
	const [loading, setLoading] = useState(-1);

	function handleRemover(index: number) {
		let data = { ...value };
		data.files.splice(index, 1);
		setValue(data);
		props.onChange(data);
	}

	function handleAdicionar(event: any, index: number) {
		let file = event.target.files[0];
		if (file) {
			setLoading(index);
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onloadend = () => {
				if (typeof reader.result === "string") {
					let data = { ...value };
					data.files[index] = {
						fileId: undefined,
						fileName: file.name,
						contentType: file.type,
						data: reader.result,
						blob: file,
					};
					if (multiple === true && Number(props.pergunta.maxAnswers) > data.files.length && index === data.files.length - 1) {
						data.files.push(fileEmpty);
					}
					setValue(data);
					props.onChange(data);
					setLoading(-1);
				}
			};
		}
	}

	const multiple = Number(props.pergunta.maxAnswers) > 1;

	return (
		<div className={`d-flex flex-wrap gap-2 ${multiple ? "" : "justify-content-center"}`}>
			{value.files.map((file, fileIndex) => {
				return (
					<Form.Label
						className="mb-0"
						key={fileIndex}
						title={file.fileName}
						onClick={(event) => {
							if (file.fileName && multiple) {
								event.preventDefault();
								handleRemover(fileIndex);
							}
						}}
						style={{ cursor: "pointer", width: multiple ? 150 : 350, height: multiple ? 150 : 350, borderStyle: "dashed", aspectRatio: 1 }}
					>
						<div className={`d-flex flex-column justify-content-center align-items-center p-2`} style={{ width: "100%", height: "100%" }}>
							{loading === fileIndex ? (
								<Spinner className="mb-2" />
							) : (
								<>
									{file.fileName && (
										<span className="small fw-normal" style={{ wordBreak: "break-all", maxHeight: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
											{file.fileName}
										</span>
									)}
									<Icon path={file.fileName ? mdiClose : mdiUpload} size={2} />
								</>
							)}
						</div>

						<Form.Control
							className="d-none"
							type="file"
							onChange={(e) => {
								handleAdicionar(e, fileIndex);
							}}
						/>
					</Form.Label>
				);
			})}
		</div>
	);
}
